import { render, staticRenderFns } from "./orderServe.vue?vue&type=template&id=444b0dbe&scoped=true&"
import script from "./orderServe.vue?vue&type=script&lang=js&"
export * from "./orderServe.vue?vue&type=script&lang=js&"
import style0 from "./orderServe.vue?vue&type=style&index=0&id=444b0dbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444b0dbe",
  null
  
)

export default component.exports